jQuery(function ($) {
    const $sidebar = $(".sticky-sidebar");
    if (!$sidebar.length) return;
    const $container = $(".content-with-sidebar");
    const $wrapper = $sidebar.parent();
    if (!$container.length || !$wrapper.length) return;

    const offset = 90; // Distance from top when sticky starts
    const desktopBreakpoint = 1024;
    let originalWidth = $sidebar.outerWidth();

    // Function to check if device is desktop
    function isDesktop() {
        return $(window).width() > desktopBreakpoint;
    }

    // Function to reset sidebar to normal state
    function resetSidebar() {
        $sidebar.css({ position: "", top: "", width: "" });
        $wrapper.css("padding-top", "");
        $wrapper.css("min-height", "");
    }

    $(window).on("scroll", function () {
        // Only apply sticky behavior on desktop
        if (!isDesktop()) {
            resetSidebar();
            return;
        }

        const scrollY = $(this).scrollTop();
        const containerTop = $container.offset().top;
        const containerBottom = containerTop + $container.outerHeight();
        const sidebarHeight = $sidebar.outerHeight();

        const containerHitsOffset = scrollY >= containerTop - offset;
        const containerEndHitsSidebar =
            scrollY + offset + sidebarHeight >= containerBottom;

        if (containerHitsOffset && !containerEndHitsSidebar) {
            $sidebar.css({
                position: "fixed",
                top: offset + "px",
                width: originalWidth + "px",
            });
            $wrapper.css("padding-top", "23rem");
            $wrapper.css("min-height", sidebarHeight + "px");
        } else if (containerHitsOffset && containerEndHitsSidebar) {
            const sidebarTop = containerBottom - sidebarHeight - scrollY;
            $sidebar.css({
                position: "fixed",
                top: sidebarTop + "px",
                width: originalWidth + "px",
            });
            $wrapper.css("padding-top", "23rem");
            $wrapper.css("min-height", sidebarHeight + "px");
        } else {
            $sidebar.css({ position: "", top: "", width: "" });
            $wrapper.css("padding-top", "");
            $wrapper.css("min-height", "");
        }
    });
});
